import React from 'react';
import { Link } from 'react-router-dom';

import { Button, TableCell } from '@mui/material';
import { ClientRoute } from 'app/route/client';
import TableRow from '@mui/material/TableRow';
import { Client, ClientModel } from 'api/dto/Client.dto';
import { getClientPlanName } from 'model/ClientPlanType';
import { compilePath } from 'router/compilePath';

namespace ClientsTableBody {
  export type Props = {
    client: ClientModel;
    onViewClick: (id: string) => void;
  };
}

export const ClientsTableBody: React.FC<ClientsTableBody.Props> = (props) => {
  return (
    <TableRow data-testid="clientItem">
      <TableCell data-testid="clientName">{props.client.name}</TableCell>
      <TableCell data-testid="clientPlan">{getClientPlanName(props.client.plan)}</TableCell>
      <TableCell align="center">
        <Button data-testid="viewClient" href={props.client.url} color="primary" target="_blank">
          View
        </Button>
        <Button
          to={compilePath(ClientRoute.Project.ACCOUNT_SETTINGS, {
            id: Client.getFirstPulseTemplateId(props.client),
          })}
          component={Link}
          color="secondary"
          data-testid="editClient"
        >
          Edit
        </Button>
      </TableCell>
    </TableRow>
  );
};
